import React from 'react';
import { InfoWindowF, MarkerF, CircleF } from '@react-google-maps/api';

import styles from './google-maps.module.scss';

const options = {
  strokeColor: 'gray',
  strokeOpacity: 0.1,
  strokeWeight: 1,
  fillColor:
    'radial-gradient(50% 50% at 50% 50%, rgba(51, 51, 51, 0) 0%, rgba(51, 51, 51, 0.15) 100%)',
  fillOpacity: 0.35,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  zIndex: 1,
};

export default function CustomMarker({
  position,
  clusterer,
  onClick,
  activeMarker,
  icon,
}) {
  return (
    <MarkerF
      icon={icon}
      position={{
        lat: Number(position?.house?.lat),
        lng: Number(position?.house?.lng),
      }}
      clusterer={clusterer}
      onClick={() => onClick(position?.id)}
    >
      {position.id === activeMarker && (
        <>
          <CircleF
            center={{
              lat: Number(position?.house?.lat),
              lng: Number(position?.house?.lng),
            }}
            options={options}
            radius={Number(position?.coverage)}
          />
          <InfoWindowF
            onCloseClick={() => onClick(null)}
            position={{
              lat: Number(position?.house?.lat),
              lng: Number(position?.house?.lng),
            }}
          >
            <div
              className={styles.infoWindow}
              itemScope
              itemType='https://schema.org/Property'
            >
              <div className={styles.infoWindowCity}>
                {position?.city?.name}
              </div>
              <div className={styles.infoWindowStreet}>
                {position?.house?.name}
              </div>
              <div className={styles.infoWindowCoverage}>
                {position?.coverage}
              </div>
            </div>
          </InfoWindowF>
        </>
      )}
    </MarkerF>
  );
}
